import { useState } from 'react';
import { Worker } from 'app/types/worker';
import { useCreateDocumentMutation, useUploadDocumentFileMutation } from 'app/services/workers';
import DocumentForm, { toApiDate } from './Form';

const CreateDocument = ({ worker }: { worker: Worker }) => {
  const [ create, documentMeta ] = useCreateDocumentMutation();
  const [ uploadFile, fileMeta ] = useUploadDocumentFileMutation();
  const [ meta, setMeta ] = useState<any>({ isSuccess: false, data: {} });

  const onSubmit = async (values: any) => {
    const document = await create({
      WorkerId: worker.Id,
      DocumentTypeId: values.DocumentTypeId,
      ValidFrom: toApiDate(values.ValidFrom),
      ValidTo: toApiDate(values.ValidTo),
    } as any).unwrap();

    const first = (values.File as any[] | undefined)?.[0];
    if (first?.originFileObj) {
      // No unwrap: a failed upload doesn't undo the save, the exceptions middleware shows its toast.
      await uploadFile({ documentId: document.Id, file: first.originFileObj });
    }

    setMeta({ isSuccess: true, data: { Id: document.Id } });
  };

  return <DocumentForm
    handleSubmit={onSubmit}
    unitId={worker.UnitId}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: documentMeta.isLoading || fileMeta.isLoading,
      isError: documentMeta.isError,
      error: documentMeta.error,
      data: meta.data
    }}
  />;
};

export default CreateDocument;
